
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

interface PropertyBasicInfoProps {
  formData: {
    title: string;
    shortName: string;
    shortDescription: string;
    longDescription: string;
    airbnbUrl: string;
    price: number;
    rating: number;
  };
  onInputChange: (field: string, value: any) => void;
}

const PropertyBasicInfo = ({ formData, onInputChange }: PropertyBasicInfoProps) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="title">Título *</Label>
          <Input
            id="title"
            value={formData.title}
            onChange={(e) => onInputChange('title', e.target.value)}
            placeholder="Título de la propiedad"
            required
          />
        </div>
        <div>
          <Label htmlFor="shortName">Nombre corto *</Label>
          <Input
            id="shortName"
            value={formData.shortName}
            onChange={(e) => onInputChange('shortName', e.target.value)}
            placeholder="Nombre corto interno"
            required
          />
        </div>
      </div>

      <div>
        <Label htmlFor="shortDescription">Descripción corta *</Label>
        <Textarea
          id="shortDescription"
          value={formData.shortDescription}
          onChange={(e) => onInputChange('shortDescription', e.target.value)}
          placeholder="Descripción corta para listados"
          rows={3}
          required
        />
      </div>

      <div>
        <Label htmlFor="longDescription">Descripción larga</Label>
        <Textarea
          id="longDescription"
          value={formData.longDescription}
          onChange={(e) => onInputChange('longDescription', e.target.value)}
          placeholder="Descripción detallada de la propiedad"
          rows={5}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="airbnbUrl">URL de Airbnb</Label>
          <Input
            id="airbnbUrl"
            value={formData.airbnbUrl}
            onChange={(e) => onInputChange('airbnbUrl', e.target.value)}
            placeholder="https://www.airbnb.com/..."
            type="url"
          />
        </div>
        <div>
          <Label htmlFor="price">Precio por noche (MXN) *</Label>
          <Input
            id="price"
            type="number"
            min="0"
            value={formData.price}
            onChange={(e) => onInputChange('price', parseInt(e.target.value) || 0)}
            placeholder="Precio"
            required
          />
        </div>
      </div>

      <div>
        <Label htmlFor="rating">Calificación (0-5)</Label>
        <Input
          id="rating"
          type="number"
          step="0.1"
          min="0"
          max="5"
          value={formData.rating}
          onChange={(e) => onInputChange('rating', parseFloat(e.target.value) || 0)}
          placeholder="Calificación promedio"
        />
      </div>
    </div>
  );
};

export default PropertyBasicInfo;
